<template>

    <div class="layout__padding-clear">

        <div class="text__align-center text__colour-white layout__margin__bottom-25px">
            <div class="layout__padding-clear layout__width-50 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                <h2 class="text__colour-teal">Get a Price</h2>
                <div class="layout__padding-20-0 text__size-18 text__colour-grey">Fill in a few quick details and receive an instant price, valid for 30 days</div>
            </div>
        </div>

        <!--{{this.selectedProduct}}-->

        <div class="layout__padding-clear layout__width-800px">
            <Stepguide v-bind:stepCount="2"></Stepguide>
            <h3 class="text__colour-teal text__align-center layout__padding-20-0">Your quote</h3>
        </div>

        <div class="layout__width-60 layout__padding-clear">

                <div class="component__columns-2">
                    <div class="layout__position-right layout__margin__right-40px">
                        <img class="layout__height-100px layout__width-100px layout__padding-20-0 layout__position-center"
                             v-bind:src="selectedProduct.pictureSmall">
                        <p class="text__align-center">{{selectedProduct.name}}</p>
                    </div>
                </div>
                <div class="component__columns-2">
                    <div class="layout__padding-clear">
                        <div class="text__colour-teal text__size-18 layout__padding-20-0">Job
                            Details
                        </div>
                        <p class="layout__padding-10px-0" v-if="JSON.parse(this.returnCookie('_role')) !== null && (!JSON.parse(this.returnCookie('_role')).includes('Customer'))">Product Code: <span class="text__colour-teal">{{this.quoteJob.printJobSpec.fCode}}</span></p>
                        <p class="layout__padding-10px-0">Product: <span class="text_colour-909399">{{this.quoteJob.printJobSpec.name}}</span>
                        </p>
                        <p class="layout__padding-10px-0">Paper Type:
                            <span class="text_colour-909399">
                                <span v-if="this.quoteJob.printJobSpec.stockType === 'LF23'">Duratran</span>
                                <span v-else-if="this.quoteJob.printJobSpec.stockType === 'INTRAN'">Intran</span>
                                <span v-else-if="this.quoteJob.printJobSpec.stockType === 'TRU'">Trucard</span>
                                <span v-else>{{this.quoteJob.printJobSpec.stockType}}</span>
                            </span>
                        </p>
                        <p class="layout__padding-10px-0">Paper Weight:
                            <span class="text_colour-909399">
                                <span v-if="this.quoteJob.printJobSpec.stockWeight === 'LF23'">Duratran</span>
                                <span v-else>{{this.quoteJob.printJobSpec.stockWeight}}</span>
                            </span>
                            <span class="text_colour-909399"
                                  v-show="quoteJob.printJobSpec.stockType !== 'TRUCARD' && quoteJob.printJobSpec.stockType !== 'INTRAN' && quoteJob.printJobSpec.stockType !== 'LF23' && quoteJob.printJobSpec.stockType">gsm</span>
                        </p>
                        <p class="layout__padding-10px-0">Lamination:
                            <span class="text_colour-909399">
                                <span v-if="quoteJob.printJobSpec.lamination === 'GLOSS LAM'">Gloss Lamination</span>
                                <span v-else-if="quoteJob.printJobSpec.lamination === 'MATT LAM'">Matt Lamination</span>
                                <span v-else>No Lamination</span>
                            </span>
                        </p>
                        <p class="layout__padding-10px-0">Quantity: <span class="text_colour-909399">{{this.quoteJob.printJobSpec.quantity}}</span>
                        </p>
                    </div>
                </div>
        </div>
        <div class="layout__container layout__overflow-hidden">
            <div class="layout__width-60 layout__padding-clear">
                <div class="layout__margin-60-0">
                    <div class="layout__padding-clear layout__margin-30-0">
                        <div class="layout__padding-clear layout__border__top-bottom-2px text__align-center layout__padding-40px-0">

                            <p class="text__size-18" v-if="JSON.parse(this.returnCookie('_role')) !== null && (!JSON.parse(this.returnCookie('_role')).includes('Customer'))">Unit Price:
                                <span class="text__colour-teal">{{quoteJob.netUnitPrice}}</span></p>
                            <p class="text__size-18">Total Price (ex.vat): <span class="text__colour-teal">{{quoteJob.netTotalOfflinePrice}}</span>
                            </p>
                        </div>

                        <div class="layout__padding-clear layout__padding-40px-0 text__align-center">
                            <el-button class="button__base button-teal layout__width-200px layout__margin__right-20px"
                                       v-on:click="amendQuote()">
                                Amend Options
                            </el-button>
                            <el-button class="button__base button-red layout__width-200px"
                                       v-on:click="newQuote()">
                                Start again
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

    import Router from '../../../router';
    import {axios} from '@/mixins/Axios.js';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "quoteSelection",
        mixins: [axios],
        props: {
            quoteJob: Object,
            selectedProduct: Object,
            products: Array,
        },
        components: {
            Stepguide
        },
        data() {
            return {
                generationDate: new Date().toLocaleDateString('en-GB') + ' ' + new Date().toLocaleTimeString('en-GB'),
                weights: [],
                types: [],
                laminations: [],
                lam: '',
                quantities: [],
                minQuantity: 0,
                jobReference: '',
                activeName: ['1'],
                weight: true,
                lamination: false,
                quantity: false,
                tabPosition: 'top',
                activeTab: 'weight',
                completedOrder: true,
                rules: {
                }
            }
        },
        // computed: {
        //     lamination() {
        //         return this.quoteJob.printJobSpec.lamination;
        //     }
        // },
        created() {
            if (typeof this.quoteJob === 'undefined') {
                this.quoteJob = JSON.parse(window.sessionStorage.getItem('_quoteJob'))
                console.log(this.quoteJob)
            }
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_quoteJob', JSON.stringify(this.quoteJob));
        },
        methods: {
            newQuote() {
                window.sessionStorage.removeItem('_quoteJob')
                window.sessionStorage.removeItem('_quoteSummary')
                window.sessionStorage.removeItem('_quoteProducts')
                window.sessionStorage.removeItem('_selectedProduct')

                Router.push({
                    name: '/get-price/products'
                });
            },
            amendQuote() {


                Router.push({
                    name: '/get-price/selections',
                    params: {
                        quoteJob: this.quoteJob,
                        products: this.products,
                    }
                });
            },
        }
    };
</script>
